import { TranslateService } from "@ngx-translate/core";

import { XLSRowBuilder } from "./xls-report";
import { ITachographDaySegment } from "@src/app/interfaces/tachograph.interface";
import { formatDate } from '../date';
import { getTachoStatusNameById } from "@src/app/views/tachograph-charts/tachograph-chart/tachograph-chart.factory";
import { formatDurationShort } from "@src/app/views/tachograph-charts/tachograph-chart/tachograph-chart.utils";

export class XLSTachoRowBuilder implements XLSRowBuilder<ITachographDaySegment> {
  constructor(private translate: TranslateService) {}

  public buildRow(entry: ITachographDaySegment) {
    return {
      [this.translate.instant('dateFrom')]: formatDate('dd.MM.yyyy HH:mm:ss', new Date(entry.From)),
      [this.translate.instant('dateTo')]: formatDate('dd.MM.yyyy HH:mm:ss', new Date(entry.To)),
      [this.translate.instant('status')]: getTachoStatusNameById(entry.State, this.translate),
      [this.translate.instant('duration')]: formatDurationShort(new Date(entry.From), new Date(entry.To)),
    };
  }
}
